<template>
  <div class="list-container" :style="'background:'+theme.themeSubColor">
    <div class="nav">
      <h2>{{theme.name ? theme.name : '全国青少年编程能力测评系统'}}</h2>
      <!--<div class="user-wrap" v-if="!$store.state.theme.hide_info">-->
        <!--<span class="user" v-if="user || $store.state.account">-->
          <!--<i :style="`background: url('${!user || user.avatar_url}') no-repeat center / cover;`"></i>-->
          <!--{{ $store.state.account || user.fullname || user.nickname}}-->
        <!--</span>-->
        <!--<div class="user-pop">-->
          <!--<ul class="user-func">-->
            <!--<li @click="userSetting"-->
                <!--@mouseenter="(event) => styleChange(event, true)"-->
                <!--@mouseleave="(event) => styleChange(event)">个人设置</li>-->
            <!--<li @click="logout"-->
                <!--@mouseenter="(event) => styleChange(event, true)"-->
                <!--@mouseleave="(event) => styleChange(event)">退出登录</li>-->
          <!--</ul>-->
        <!--</div>-->
      <!--</div>-->
      <div class="user-wrap">
        <div class="user" v-if="(user || $store.state.account) && isDzkApp">
          <i :style="`background: url('${!user || user.avatar_url}') no-repeat center / cover;`"></i>
          <div class="info">
            <p>{{user.fullname || user.nickname || $store.state.account}}</p>
            <p class="id">ID：{{ user.id }}</p>
          </div>
        </div>
        <p class="detect" @click="goDetect" v-if="theme.deviceCheckOpen"><i class="icon-device"></i>设备检测</p>
        <p class="logout" @click="logout" v-if="!theme.hide_info && !touristsVal && !isDzkApp"><i class="icon-logout"></i>退出登录</p>
      </div>
      <div class="bg" :style="'background:'+theme.themeColor"></div>
    </div>
    <div class="list-wrap">
      <div class="header">
        <ul class="tab-wrap">
          <li :style="'color: '+theme.themeColor" @click="(event) => changeTab(event, 1)" :class="{ active: tab === 1 }">
            待完成<i :style="'background: '+theme.themeColor"></i></li>
          <li @click="(event) => changeTab(event, 2)" :class="{ active: tab === 2 }">已完成<i></i></li>
        </ul>
        <!--<div class="search-wrap">-->
          <!--<input class="search-input" @change="getExams" placeholder="请输入考试名称" v-model="exam_name" />-->
        <!--</div>-->
      </div>
      <div class="rolling">
        <ul class="list" v-if="this.total > 0">
          <li class="list-item"
              @mouseenter="(event) => ItemChange(event, true)"
              @mouseleave="(event) => ItemChange(event)"
              v-for="(item, index) in examList"
              :key="'test'+index">
            <div class="test-info">
              <h3>{{item.exam_name}}<span :class="changeStatus(item.status)">{{item.status | formateStatus}}</span></h3>
              <p class="time">
                <i class="icon"></i>
                <span>考试时间：{{item.start_time | date('Y-m-d H:i')}} ~ {{item.end_time | date('Y-m-d H:i')}}</span></p>
              <p class="score-info">
                <span>总分：{{item.score}}分</span>
                <!--<span>及格分：{{item.pass_score}}分</span>-->
                <span>答题时间：{{item.exam_time}}分钟</span>
              </p>
            </div>
            <div class="func-wrap">
              <div v-if="item.status > 3" class="score right-wrap">
                <p v-if="item.result > -1 || item.result === 0"><span>{{item.result}}</span>分</p>
                <!-- <p v-else-if="!item.result">成绩未公布</p> -->
                <!-- <p class="no-score" v-else>/</p>得分 -->
              </div>
              <div class="btn-wrap">
                <span @click="reset(item)"
                      v-if="tab === 2 && ($route.path.split('/')[1].indexOf('nctsimutest') >= 0
                      || item.repeat_test
                      || $route.path.split('/')[1].indexOf(eduteacherRoute) >= 0
                      || $route.path.split('/')[1].indexOf(nocbcmRoute) >= 0)"
                      class="btn right-wrap empty-btn"
                      :style="'border: 1px solid'+theme.themeColor+ 'color: '+theme.themeColor"
                  >重考</span>
                <span @click="getTestInfo(item)"
                      v-if="tab === 1 || ($route.path.split('/')[1].indexOf(weishengRoute) < 0 && item.is_show_result === 1)"
                      :class="{ 'disable-btn': getBtnDisable(item) }"
                      class="btn right-wrap"
                      :style="'box-shadow: '+ theme.buttonShadow+'background: '+ theme.buttonBackground"
                      >{{examStatus(item)}}</span>
              </div>
            </div>
          </li>
        </ul>
        <div class="no-data" v-else-if="!showSaveLoading">
          暂无数据
        </div>
      </div>
      <div class="loading-mask" v-show="showSaveLoading">
        <div class="loading-wrap">
          <looping-rhombuses-spinner
            :animation-duration="2500"
            :rhombus-size="30"
            :color="theme.themeColor.split(';')[0]"
            class="loading-icon"
          />
          <p>数据加载中...</p>
        </div>
      </div>
      <el-pagination
        v-if="this.total >= 10"
        class="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="limit"
        :page-sizes="[10, 20]"
        layout="prev, pager, next, sizes, jumper"
        :total="total">
      </el-pagination>
    </div>
    <user-info :show.sync="show"></user-info>
    <modal
      width="400px"
      speed="fast"
      noOutClose
      maskNoClick
      :show="showLateTip"
      enter-active-class="fadeIn"
      leave-active-class="fadeOut"
      @update:show="showLateTip = false"
      class="late-tip-modal">
      <p slot="header">提示</p>
      <p slot="content" class="text">
        你已迟到{{ lateTime }}分钟，不能进入考场考试。
      </p>
      <div slot="footer">
        <button
          :style="'box-shadow: '+ theme.buttonShadow+'background: '+ theme.buttonBackground"
          @click="showLateTip = false">知道了</button>
      </div>
    </modal>
    <detect-tip-modal v-if="showDetectModal" @close="showDetectModal = false" @goTest="continueTest"></detect-tip-modal>
    <tourists-info-modal @setTouristsMsg="setTouristsMsg" :visible="touristsVisible" @close="createNewTourists" ></tourists-info-modal>
  </div>
</template>

<script>
import { Pagination } from 'element-ui'
import LoopingRhombusesSpinner from 'epic-spinners/src/components/lib/LoopingRhombusesSpinner'
import UserInfo from '@/views/UserInfo'
import { mapState } from 'vuex'
import { get, post } from '@/utils/ajax'
import { getTouristsVal, getTouristsToken, getTouristsUserId, isInDzkApp } from '@/utils'
import Modal from '@/components/Modal'
import DetectTipModal from '@/views/components/DetectTipModal'
import TouristsInfoModal from '@/views/List/infoMsg.vue'

export default {
  components: {
    LoopingRhombusesSpinner,
    ElPagination: Pagination,
    UserInfo,
    Modal,
    TouristsInfoModal,
    DetectTipModal
  },
  computed: {
    ...mapState(['user', 'theme', 'weishengRoute', 'eduteacherRoute', 'nocbcmRoute']),
    getBtnDisable: function () {
      return function (data) {
        if (this.tab === 2 && !data.result && data.result !== 0) {
          return true
        }
        if (this.tab === 1) {
          const isInTime = data.start_time - this.originTime <= 7200000 // 提前2小时打开
          const lastTime = data.end_time >= this.originTime // 在考试的范围内，最大不超过结束时间
          // examinee_status 1：未开始考试，2：已进入考试，进行中，3：已交卷 4：迟到
          return data.status >= 3 || data.examinee_status === 3 || !isInTime || !lastTime
        }
      }
    }
  },
  data() {
    return {
      originTime: 0,
      showSaveLoading: true,
      touristsVisible: false, // 游客信息模态框
      exam_name: '',
      tab: 1,
      show: false,
      limit: 10,
      page: 1,
      total: '',
      examList: [],
      showLateTip: false,
      lateTime: 0,
      selectItem: {},
      hasTouristsMsg: false, // 判断是否有游客信息
      showDetectModal: false,
      touristsVal: false,
      isDzkApp: isInDzkApp()
    }
  },
  filters: {
    formateStatus (value) {
      switch (value) {
        case 1:
          return '未开始'
        case 2:
          return '进行中'
        case 3:
          return '已结束'
        case 4:
          return '批改中'
        case 5:
          return '已批改'
        default:
          return value
      }
    }
  },
  async mounted () {
    const isTourists = getTouristsVal()
    if (!isTourists) {
      await this.$store.dispatch('getTestInfo')
      await this.$store.dispatch('getUserInfo')
    }
    this.touristsVal = isTourists
    this.originTime = await get('/home/common/times')
    this.getExams()
  },
  methods: {
    // 判断是否有游客信息
    setTouristsMsg(bol) {
      this.hasTouristsMsg = bol
    },
    // 判断是否生成新的游客账号
    createNewTourists(flag) {
      if (!flag) {
        this.touristsVisible = flag
      }
    },
    examStatus (item) {
      if (this.tab === 2) {
        return '查看答卷'
      }
      return item.exam_going ? '继续考试' : '开始考试'
    },
    changeStatus (status) {
      if (!status) return
      switch (status) {
        case 1:
          return ''
        case 2:
          return 'proceed'
        case 3:
          return 'end'
        case 4:
          return 'checking'
        case 5:
          return 'finish'
        default:
          return ''
      }
    },
    // 改变每页限制数
    handleSizeChange (val) {
      this.limit = val
      this.getExams()
    },
    handleCurrentChange (val) {
      this.page = val
      this.getExams()
    },
    async getExams () {
      // HACK: 兼容游客模式的请求，后续可以让后端兼容接口，或者前端拆成两个页面进行判断处理
      const isTourists = getTouristsVal()
      const token = getTouristsToken()
      const _userid = this.user.id || getTouristsUserId()
      const _exam_type = isTourists ? 3 : 2
      let examList = {
        items: [],
        total: 0
      }
      let query = ''
      const body = {
        limit: this.limit,
        page: this.page
      }
      this.showSaveLoading = true
      let siteId = ''
      if (this.theme.id) {
        siteId = `&site_id=${this.theme.id}`
      }
      // 声明一下，因为游客模式下已完成情况，当有登录态要调有登录态的接口没有就不调，未完成情况都是调没有登录态的接口
      // 有空的人可以自己封装修改一下。
      if (isTourists) {
        if (Number(this.tab) === 2) {
          query = `?exam_name=${this.exam_name}&tab=${this.tab}&exam_type=${_exam_type}${siteId}`
          examList = token ? await post(`/home/edu/examinees/${_userid}/exams${query}`, body, { ignoreTourists: true }) : []
        } else {
          query = `?tab=${this.tab}&exam_type=3`
          examList = await post(`/home/exams/sites/${this.theme.id}${query}`, body)
        }
      } else {
        query = `?exam_name=${this.exam_name}&tab=${this.tab}&exam_type=${_exam_type}${siteId}`
        examList = await post(`/home/edu/examinees/${_userid}/exams${query}`, body, { ignoreTourists: true })
      }
      this.examList = examList.items || []
      this.showSaveLoading = false
      this.total = examList.total
      const examId = Number(localStorage.getItem('examId'))
      const selectItem = this.examList.find(item => { return item.exam_id === examId })
      if (selectItem && this.$route.params.fromDetect) { // 从设备检测页面进入考试
        this.goTest(selectItem)
      }
    },
    changeTab (e, tab) {
      e.target.style = `color: ${this.theme.themeColor}`
      e.target.getElementsByTagName('i')[0].style = `background:  ${this.theme.themeColor}`
      if (tab === 1) {
        e.target.parentNode.getElementsByTagName('li')[1].style = ''
      } else {
        e.target.parentNode.getElementsByTagName('li')[0].style = ''
      }
      this.examList = []
      this.tab = tab
      this.page = 1
      this.getExams()
    },
    userSetting () {
      this.show = true
    },
    styleChange (e, theme) {
      if (theme) {
        e.target.style = `color: ${this.theme.themeColor} background: ${this.theme.themeSubColor}`
      } else {
        e.target.style = 'color: #333; background: #fff;'
      }
    },
    ItemChange (e, theme) {
      if (theme) {
        e.target.style = `box-shadow: 0px 8px 16px 0px ${this.theme.lightThemeColor}`
      } else {
        e.target.style = 'box-shadow: none;'
      }
    },
    async logout () {
      await this.$store.dispatch('logout')
      localStorage.clear()
      if (window.location.href.indexOf(CONFIG.noc2024) === -1) {
        this.$router.push({ name: 'login' })
      }
    },
    // 游客账号体系逻辑走
    async touristsJs (item) {
      if (this.hasTouristsMsg) {
        this.touristsVisible = true
      } else {
        this.$router.push({ name: 'touristsmsg',
          query: {
            date: new Date().getTime()
          } })
      }
    },
    async getTestInfo (item) {
      if (this.getBtnDisable(item)) return
      localStorage.examId = item.exam_id
      if (this.tab === 1) {
        // TODO: 判断是否是游客账号体系
        const isTourists = getTouristsVal()
        if (isTourists) {
          this.touristsJs(item)
        } else {
          this.goTest(item)
        }
      } else {
        window.open(`${location.origin}/${location.href.split('/')[3]}/showPaper?id=${item.exam_id}`, '__blank')
      }
    },
    async goTest(item, flag = 0) {
      // examinee_status 1：未开始考试，2：已进入考试，进行中，3：已交卷 4：迟到
      this.selectItem = item
      // 各种开关
      const res = await get(`/home/exams/check/${item.exam_id}`)
      this.$store.commit('SETSTATE', { key: 'examConfig', value: res })
      if (item.examinee_status === 4 && res.last_come_in_minute) { // 迟到了就显示不能进入
        this.lateTime = res.last_come_in_minute
        this.showLateTip = true
        return
      }
      const noticeConfig = res.exam_config.find(item => {
        return item.label === 'LARGE_EXAM#exam_notice'
      })
      const openNotice = noticeConfig && noticeConfig.actual_value === '1'
      localStorage.setItem('needNotice', openNotice)
      const needIdentity = item.examinee_status === 1 && res.identity_verification === 1 && item.verification_pass === 0
      localStorage.setItem('needIdentity', needIdentity) // 保存在本地，为了设备检测完成进入考试时，能直接判断是否进行身份核验
      if (!flag) { // 先判断是否需要设备检测
        this.showDetectModal = await this.checkDetect()
        if (this.showDetectModal) {
          return
        }
      }
      // 已进入考试 ||（未开始考试 && 未打开考试须知 && (全局/个人)关闭了身份核验开关）
      if (item.examinee_status === 2 || (item.examinee_status === 1 && !openNotice && (res.identity_verification === 0 || item.verification_pass === 1))) {
        this.$router.push({ name: 'pretest' }) // 直接进入考试
      } else if (needIdentity || openNotice) { // 未开始考试且全局/个人都打开身份验证/打开考试须知，进入身份核验
        this.$router.push({ name: 'identityCheck' })
      }
    },
    async checkDetect() { // 判断该设备是否需要设备检测
      const finger = this.$store.state.browserFinger
      const { deviceCheckInfo } = await get(`/home/devices/check/info?serialNumber=${finger}`)
      const info = []
      deviceCheckInfo.forEach(item => {
        info[item.deviceType] = item.deviceStatus
      })
      let needDetect = false
      for (const type of this.theme.deviceTypes) {
        if (!info[type]) {
          needDetect = true
          break
        }
      }
      return needDetect
    },
    // 重考
    async reset (item) {
      await post(`/home/edu/examinees/exams/reset`, { exam_id: item.exam_id, examinee_id: item.examinee_id })
      localStorage.examId = item.exam_id
      // 重置考生状态
      item.examinee_status = 1
      item.exam_going = false
      localStorage.removeItem('currentQuestionId') // 去掉上一次答题进度的缓存
      this.goTest(item)
    },
    // 设备检测提示弹框，点击进入考试按钮
    continueTest() {
      this.goTest(this.selectItem, 1) // 不进行设备检测
    },
    goDetect() {
      const routeUrl = this.$router.resolve({
        name: 'detect'
      })
      window.open(routeUrl.href, '_blank')
    }
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.list-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 1400px;
}
.nav {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  height: 257px;
  min-height: 257px;
  color: #fff;
  .bg {
    position: absolute;
    width: 18000px;
    height: 18000px;
    border-radius: 50%;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
  h2 {
    z-index: 1;
    font-size: 30px;
    font-weight: 400;
    color: #fff;
    margin: 23px 0 0 60px;
    height: 50px;
  }
  .user-wrap {
    position: relative;
    z-index: 1;
    margin: 23px 60px 0 0;
    line-height: 30px;
    height: 30px;
    display: flex;
    font-size: 14px;
    i {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }
    .detect, .logout {
      display: flex;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
    }
    .logout {
      margin-left: 30px;
    }
    &:hover {
      .user-pop {
        display: block;
      }
    }
  }
  .user {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 300;
    height: 30px;
    margin-right: 30px;
    // min-width: 120px;
    i {
      display: inline-block;
      vertical-align: middle;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      // margin-right: 10px;
      background: url('https://static-user-center.codemao.cn/user_0005.png') no-repeat center / cover;
    }
    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-weight: 400;
      .id {
        font-size: 12px;
        font-weight: 300;
        line-height: 12px;
      }
    }
  }
  .user-pop {
    display: none;
    position: absolute;
    padding-top: 15px;
    left: 50%;
    transform: translateX(-50%);
  }
  .user-func {
    background: #fff;
    padding: 10px 0;
    border-radius: 3px;
    box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.15);
    &::before {
      content: '';
      position: absolute;
      border: 8px solid #fff;
      border-left-color: transparent;
      border-right-color: transparent;
      border-top-color: transparent;
      top: -1px;
      right: 49px;
    }
    li {
      cursor: pointer;
      width: 160px;
      height: 46px;
      line-height: 46px;
      text-align: center;
      color: #333;
      font-weight: 300;
      font-size: 14px;
    }
  }
  .icon-logout {
    background: url("~@/assets/images/icon-logout.png") center / cover no-repeat;
    margin-left: 30px;
  }
  .icon-device {
    background: url("~@/assets/images/icon-device.png") center / cover no-repeat;
  }
}
.list-wrap {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  width: 1400px;
  background: #fff;
  border-radius: 8px 8px 0 0;
  margin: -160px auto 0;
  box-shadow:0px 0px 20px 0px rgba(0,0,0,0.1);
}
.header {
  display: flex;
  height: 73px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #F2F7FF;
  .tab-wrap {
    margin-left: 20px;
    li {
      cursor: pointer;
      padding: 0 20px;
      float: left;
      position: relative;
      font-size: 20px;
      color: #666;
      margin-right: 10px;
      line-height: 71px;
    }
    .active {
      color: $themeColor;
      i {
        position: absolute;
        bottom: 0;
        left: 32px;
        width: 32px;
        height: 2px;
        background: $themeColor;
      }
    }
  }
  .search-wrap {
    width: 260px;
    margin-right: 40px;
  }
}
.rolling {
  flex: 1;
  position: relative;
}
.list {
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: 30px 40px 0;
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto 20px;
    width: 1120px;
    height: 144px;
    border: 1px solid #EFEEEF;
    border-radius: 4px;
    &:hover {
      box-shadow: 0 8px 16px 0 rgba(164,199,255,0.5);
    }
  }
  .test-info {
    height: 144px;
  }
  .icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 10px;
    vertical-align: -2px;
    background: url('~@/assets/images/time.jpg') no-repeat center / cover;
  }
  h3 {
    color: #333;
    font-size: 20px;
    font-weight: 500;
    margin: 20px 0 0 20px;
    span {
      display: inline-block;
      vertical-align: 3px;
      width: 72px;
      height: 26px;
      line-height: 26px;
      font-size: 14px;
      color: #397EFD;
      background: #D7E5FF;
      text-align: center;
      border-radius: 12px;
      margin-left: 20px;
    }
    .proceed {
      color: #00C882;
      background: rgba(0, 200, 130, .1);
    }
    .end {
      color: #666;
      background: rgba(0, 0, 0, .1);
    }
    .checking {
      color: #F5212D;
      background: rgba(245, 34, 45, .1);
    }
    .finish {
      color: #FF8119;
      background: rgba(255, 130, 24, .1);
    }
  }
  .time {
    color: #333;
    font-weight: 300;
    height: 22px;
    font-size: 16px;
    margin: 15px 0 0 20px;
  }
  .score-info {
    color: #999;
    font-weight: 300;
    font-size: 14px;
    margin: 15px 0 0 20px;
    span {
      margin-right: 30px;
    }
  }
  .func-wrap {
    display: flex;
    align-items: center;
    position: relative;
  }
  .right-wrap {
    display: inline-block;
  }
  .score {
    margin-right: 84px;
    font-size: 14px;
    color: #999;
    text-align: center;
    p {
      font-size: 18px;
      color: #F5222D;
      font-weight: 500;
    }
    .no-score {
      font-size: 36px;
    }
    span {
      color: #F5222D;
      font-size: 36px;
      margin-right: 2px;
    }
  }
  .btn-wrap {
    display: flex;
    flex-direction: column;
  }
  .btn {
    cursor: pointer;
    width: 160px;
    height: 42px;
    line-height: 42px;
    font-size: 16px;
    font-weight: 300;
    color: #fff;
    text-align: center;
    border-radius: 4px;
    box-shadow: $buttonShadow;
    background: $buttonBackground;
    margin-right: 64px;
    & + .btn {
      margin-top: 16px;
    }
  }
  .empty-btn {
    background: #fff;
    font-size: 18px;
    box-shadow: none;
  }
  .disable-btn {
    cursor: not-allowed;
    background: #ccc !important;
    box-shadow: none !important;
  }
}
.no-data {
  box-sizing: border-box;
  height: 301px;
  width: 400px;
  margin: 101px auto 0;
  text-align: center;
  padding-top: 210px;
  color: #333;
  font-size: 16px;
  font-weight: 300;
  background: url('~@/assets/images/no-data.png') no-repeat top / 90% 200px;
}
.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  align-items: center;
  justify-content: center;
  .loading-wrap {
    display: flex;
    flex-direction: column;
    width: 100px;
    height: 100px;
    align-items: center;
    justify-content: center;
    p {
      font-size: 14px;
      margin-top: 20px;
      color: #fff;
    }
  }
}
  .late-tip-modal {
    /deep/.modal-head {
      padding: 16px 20px;
      border-bottom: 1px solid #F1F1F1;
    }
    .text {
      font-size: 16px;
      text-align: center;
      margin-top: 10px;
    }
    button {
      @include theme-fill-btn(104px, 36px, 14px, 4px);
      margin-bottom: 10px;
    }
  }
</style>

<style lang="scss">
.list-container .search-input {
  height: 32px;
  font-size: 14px;
  font-weight: 300;
  line-height: 32px;
  border: 1px solid #dcdfe6;
  color: #606266;
  background-color: #fff;
  border-radius: 4px;
  outline: 0;
  width: 100%;
  padding: 0 15px;
}
.list-container {
  .page {
    display: flex;
    margin: 20px 0;
    justify-content: center;
  }
  .el-pager li.active+li {
    border-left: 1px solid #D9D9D9;
  }
  .el-pager li.active {
    color: #333;
    // background: $themeColor;
    border-color: #666;
  }
  .el-pager li , .el-pagination button {
    height: 32px;
    width: 32px;
    min-width: 32px;
    margin-right: 8px;
    border-radius: 4px;
    line-height: 32px;
    border: 1px solid #D9D9D9;
  }
  .el-pagination button {
    padding: 0;
  }
  .el-pagination .btn-next .el-icon, .el-pagination .btn-prev .el-icon {
    font-size: 14px;
  }
  .el-input--mini .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  .el-pagination__editor.el-input .el-input__inner {
    height: 32px;
  }
  .el-input__inner:focus {
    border-color: #000;
  }
}
.el-select-dropdown__item.selected {
  color: #000 !important;
}
.el-pagination__sizes .el-input .el-input__inner:hover {
  border-color: #ddd;
}
</style>
